import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Megaphone = function Megaphone(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "m19.674 3.457-12.5 4.31a1 1 0 0 0-.674.946v4.526a1 1 0 0 0 .734.963l12.5 3.449A1 1 0 0 0 21 16.687V4.403a1 1 0 0 0-1.326-.946Z",
      stroke: color,
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.5 8H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4M4 14l.842 5.053a1 1 0 0 0 1.11.828l2-.25a1 1 0 0 0 .859-1.171L8 14",
      stroke: color,
      strokeWidth: "2"
    })]
  });
};
export default Megaphone;